import EventEmitter from 'wolfy87-eventemitter';
import { TICKETS_POPOVER_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';

export class TicketsPopoverController extends EventEmitter {
  state: {
    isHidden: boolean;
    data?: {
      title: string;
      text: string;
      seat?: {
        id: number;
      };
    };
    standData?: {};
  };

  constructor() {
    super();

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.state = {
      isHidden: true,
      data: {
        title: null,
        text: null,
      },
      standData: null,
    };
  }

  show(data: any) {
    this.state = {
      isHidden: false,
      data,
    };

    this.emit(TICKETS_POPOVER_EVENTS.UPDATE, this.state);
  }

  hide() {
    this.state = {
      isHidden: true,
      data: null,
    };

    this.emit(TICKETS_POPOVER_EVENTS.UPDATE, this.state);
  }

  showStandPopover(data) {
    this.state = {
      isHidden: false,
      standData: data,
    };

    this.emit(TICKETS_POPOVER_EVENTS.UPDATE, this.state);
  }
}
